"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyText = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const currency_input_1 = require("@nbc-design/currency-input");
require("./currencyText.css");
/** Format monetary values based on the given locale and displays it.  */
const CurrencyText = ({ locale = 'fr', fractionDigits = 2, currency = 'CAD', value = '', hideSymbol = false, displayCurrency = false, type = 'normal', ariaLabel, className, }) => {
    const [stateValue, setStateValue] = React.useState(value);
    React.useEffect(() => {
        setStateValue((0, currency_input_1.format)(value, locale, fractionDigits, currency, hideSymbol, displayCurrency));
    }, [value, locale, fractionDigits, currency, hideSymbol, displayCurrency]);
    const classes = (0, classnames_1.default)('dsc-currencytext', type === 'deposit' && 'dsc-currencytext--deposit', className);
    return ((0, jsx_runtime_1.jsxs)("span", { className: classes, "aria-label": ariaLabel, children: [type === 'deposit' && (0, jsx_runtime_1.jsx)("span", { "aria-hidden": "true", children: "+ " }), stateValue] }));
};
exports.CurrencyText = CurrencyText;
exports.CurrencyText.displayName = 'CurrencyText';
//# sourceMappingURL=currencyText.js.map